import { formatISO, Interval, isDate } from 'date-fns';
import { PlainRangeInterface } from '../models/range.interface';

export function intervalToRange(interval: Interval): PlainRangeInterface;

export function intervalToRange(
  interval: Interval,
  inclusiveStart: boolean,
  inclusiveEnd: boolean,
  timezone?: string,
): PlainRangeInterface;

export function intervalToRange(
  interval: Interval,
  inclusiveStart: boolean = true,
  inclusiveEnd: boolean = true,
): PlainRangeInterface {
  return {
    start:
      isDate(interval.start) || typeof interval.start === 'number'
        ? formatISO(interval.start)
        : interval.start,
    end:
      isDate(interval.end) || typeof interval.end === 'number'
        ? formatISO(interval.end)
        : interval.end,
    inclusiveStart: inclusiveStart,
    inclusiveEnd: inclusiveEnd,
  };
}
